module.exports = __webpack_public_path__ + "static/media/FloorplanWithCompanion.1fc6943b.svg";